
<template>
    <div class="el-grid-card" style="width: 100%">
        <div class="el-grid-card__body">
            <el-row>
                <div class="el-grid-card__header">
                    {{ $t('label.schedule-create.title.create') }}
                </div>
            </el-row>
            <el-row style="margin-top: 30px">
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.workHours1') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle1') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t(
                                        'label.schedule-create.title.workHours1'
                                    ),
                                    1,
                                    5,
                                    6,
                                    16
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.workHours2') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle2') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t(
                                        'label.schedule-create.title.workHours2'
                                    ),
                                    1,
                                    5,
                                    6,
                                    19
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.morning') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle3') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t('label.schedule-create.title.morning'),
                                    1,
                                    5,
                                    6,
                                    12
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.afternoon') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle4') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t('label.schedule-create.title.afternoon'),
                                    1,
                                    5,
                                    12,
                                    16
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
            </el-row>
            <el-row style="margin-top: 30px">
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.evening') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle5') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t('label.schedule-create.title.evening'),
                                    1,
                                    5,
                                    16,
                                    22
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="create-schedule-box">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.always') }}
                        </p>
                        <p>
                            {{ $t('label.schedule-create.subtitle.subtitle6') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t('label.schedule-create.title.always'),
                                    0,
                                    6,
                                    0,
                                    23,
                                    59
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="create-schedule-box-custom">
                        <p class="create-schedule-box-title">
                            {{ $t('label.schedule-create.title.custom') }}
                        </p>
                        <v-btn
                            style="margin-top: 40px"
                            round
                            color="primary"
                            @click="
                                select(
                                    $t('label.schedule-create.title.custom'),
                                    'custom',
                                    0,
                                    0,
                                    0
                                )
                            "
                        >
                            {{ $t('button.text.create') }}
                        </v-btn>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
    name: 'create-global-scehdule',

    computed: {
        ...mapGetters(['selectedContainer']),
    },

    data() {
        return {}
    },

    methods: {
        async select(
            description,
            startDay,
            endDay,
            startTime,
            endTime,
            endMinute = 0,
            endSecond = 0
        ) {
            const scheduleId = await this.createScheduleTemplate(description)
            if (startDay != 'custom') {
                let parts = []
                for (let index = startDay; index <= endDay; index++) {
                    const start = moment()
                        .day(index)
                        .hour(startTime)
                        .minute(0)
                        .second(0)
                    const end = moment()
                        .day(index)
                        .hour(endTime)
                        .minute(endMinute)
                        .second(endSecond)

                    var startDuration = start.diff(
                        moment().startOf('week'),
                        'seconds'
                    )
                    var endDuration = end.diff(
                        moment().startOf('week'),
                        'seconds'
                    )

                    parts.push({
                        Start: startDuration,
                        Stop: endDuration,
                        ValidFrom: null,
                        ValidTo: null,
                        IsSimpleSchedule: false,
                    })
                }

                const promises = await parts.map(async (it) => {
                    const data = await this.createSchedulePartTemplate(
                        scheduleId,
                        it
                    )
                    return data
                })
                await Promise.all(promises)
            }

            Events.$emit('global-schedule-refresh', scheduleId)
        },

        async createScheduleTemplate(description) {
            const { data } = await this.$http.post(
                `/Container/${this.selectedContainer.ContainerID}/ScheduleTemplate`,
                {
                    Description: description,
                }
            )
            return data
        },

        async createSchedulePartTemplate(scheduleId, part) {
            const { data } = await this.$http.post(
                `/ScheduleTemplate/${scheduleId}/SchedulePartTemplate`,
                part
            )
            console.log(data)
            return data
        },
    },
}
</script>

<style>
.create-schedule-box {
    background-color: #384352;
    color: white;
    font-weight: bold;
    padding: 20px;
    width: 180px;
    height: 180px;
}

.create-schedule-box-title {
    font-size: 20px;
}

.create-schedule-box-custom {
    background-color: #cdc58c;
    font-weight: bold;
    padding: 20px;
    width: 180px;
    height: 180px;
}
</style>